import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { Setter, Store } from "../utils/storage";
import { getQuery } from "../utils/api";

const storage = Store("session");

// Initial State
const State = {
  bathrooms: [],
  loadingBathrooms: false,
};

// Actions
const Actions = (_set) => {
  const set = Setter(_set);
  const URL = process.env.REACT_APP_BATHROOM_ENDPOINT;

  // Fetch Bathrooms from REST API
  const fetchBathrooms = async () => {
    set({ loadingBathrooms: true });

    try {
      const { response, data } = await getQuery(URL);

      if (response === 200) {
        set({ bathrooms: data, loadingBathrooms: false });
      } else {
        console.error("Error fetching bathrooms: Invalid response code", response);
        set({ bathrooms: [], loadingBathrooms: false });
      }
    } catch (error) {
      console.error("Error fetching bathrooms:", error);
      set({ bathrooms: [], loadingBathrooms: false });
    }
  };

  return {
    fetchBathrooms,
  };
};

// Create Store
const BathroomsStore = create(
  persist(
    (set) => {
      const actions = Actions(set);

      return {
        ...State,
        fetchBathrooms: actions.fetchBathrooms,
      };
    },
    {
      name: "app.bathrooms",
      storage: createJSONStorage(() => storage),
    }
  )
);

export default BathroomsStore;
